module.exports = __webpack_public_path__ + "img/yellow-mustard.c25fa81d.jpg";